import React from 'react';

import HoneyTable, { makeCountryName } from './HoneyTable.js'

function TopConsumers({topConsumers}) {
  return (
    <HoneyTable
      titleBefore="Top&nbsp;"
      titleHoney="Intrusion"
      titleAfter="&nbsp;Sources"
      fields={["CountryName", "Count"]}
      pagination={false}
      data={topConsumers}
      dataTransform={makeCountryName}
    />
  );
}

export default TopConsumers;
